
import React from "react";
import { motion } from "framer-motion";

const translations = {
  en: {
    title: "About Us",
    description: "The Horn Educational Network is your trusted partner for international education. We empower students across East Africa, the Middle East, and beyond by connecting them with world-class universities in Malaysia, the UK, and other leading destinations. Our personalized support—from university admissions to visa guidance—ensures every student has the opportunity to achieve their academic dreams.",
    stats: [
      { number: "500+", label: "Students Placed" },
      { number: "50%", label: "Scholarship Success" },
      { number: "95%", label: "Visa Success Rate" }
    ]
  },
  ar: {
    title: "من نحن",
    description: "شبكة هورن التعليمية هي شريكك الموثوق في التعليم الدولي. نحن نمكن الطلاب في شرق إفريقيا والشرق الأوسط وما بعدهما من خلال ربطهم بجامعات عالمية المستوى في ماليزيا والمملكة المتحدة وغيرها من الوجهات الرائدة. يضمن دعمنا الشخصي - من القبول الجامعي إلى إرشادات التأشيرة - حصول كل طالب على فرصة لتحقيق أحلامه الأكاديمية.",
    stats: [
      { number: "+500", label: "طالب تم قبولهم" },
      { number: "50%", label: "نجاح المنح الدراسية" },
      { number: "95%", label: "معدل نجاح التأشيرة" }
    ]
  },
  so: {
    title: "Ku Saabsan",
    description: "Shabakadda Waxbarashada Horn waa lammaanahaaga lagu kalsoon yahay ee waxbarashada caalamiga ah. Waxaan awood u siinaa ardayda Bariga Afrika, Bariga Dhexe, iyo wixii ka dambeeya annagoo ku xiraya jaamacadaha heerka caalamiga ah ee Malaysia, UK, iyo meelo kale oo hormuud ah. Taageeradayada gaarka ah - laga bilaabo ogolaanshaha jaamacadda ilaa hagista fiisaha - waxay hubisaa in arday kasta uu haysto fursad uu ku gaaro riyooyinkiisa waxbarasho.",
    stats: [
      { number: "500+", label: "Arday La Aqbalay" },
      { number: "50%", label: "Guusha Deeqda" },
      { number: "95%", label: "Heerka Guusha Fiisaha" }
    ]
  }
};

function About({ language }) {
  const content = translations[language];

  return (
    <section className="py-20 bg-primary/5">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">{content.title}</h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            {content.description}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mt-12">
          {content.stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-background rounded-lg p-6 text-center shadow-lg"
            >
              <h3 className="text-4xl font-bold text-primary mb-2">{stat.number}</h3>
              <p className="text-muted-foreground">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
